const BIV_TSHIRT_MOBILE_GALLERY_QUERY = "(max-width: 1023.9px)";

function initBivTshirtMobileGalleryAutoHeight(productMedia) {
  if (productMedia.dataset.bivTshirtAutoHeightInitialized === "true") return;

  const sliderComponent = productMedia.querySelector(
    ".product-media-slider-wrap scroll-slider-component",
  );
  const slider = sliderComponent?.querySelector(".scroll-slider__slider");
  const scrollerId = sliderComponent?.dataset.id;

  if (!sliderComponent || !slider || !scrollerId) return;

  productMedia.dataset.bivTshirtAutoHeightInitialized = "true";

  const mobileQuery = window.matchMedia(BIV_TSHIRT_MOBILE_GALLERY_QUERY);
  let currentSlide =
    productMedia.querySelector("[data-initial-slide]") ||
    slider.querySelector(".product-media__item");
  let animationFrame = null;

  const resetDesktopLayout = () => {
    slider.style.removeProperty("height");
    slider.style.removeProperty("min-height");
    slider.style.removeProperty("align-items");
  };

  const getImageDrivenHeight = (slide) => {
    const image = slide.querySelector("img.image") || slide.querySelector("img");
    if (!image) return null;

    const intrinsicWidth =
      Number.parseFloat(image.getAttribute("width")) || image.naturalWidth;
    const intrinsicHeight =
      Number.parseFloat(image.getAttribute("height")) || image.naturalHeight;

    if (!(intrinsicWidth > 0) || !(intrinsicHeight > 0)) return null;

    const slideRect = slide.getBoundingClientRect();
    const imageRect = image.getBoundingClientRect();
    const renderedWidth = imageRect.width || slideRect.width;

    if (!(renderedWidth > 0)) return null;

    const topOffset = Math.max(0, imageRect.top - slideRect.top);
    const naturalHeight = renderedWidth * (intrinsicHeight / intrinsicWidth);

    return Math.ceil(topOffset + naturalHeight);
  };

  const getFallbackHeight = (slide) => {
    const media = slide.querySelector("video, model-viewer, iframe, svg");
    if (!media) return null;

    const slideRect = slide.getBoundingClientRect();
    const mediaRect = media.getBoundingClientRect();
    if (!(mediaRect.height > 0)) return null;

    return Math.ceil(Math.max(0, mediaRect.top - slideRect.top) + mediaRect.height);
  };

  const syncHeight = (nextSlide = null) => {
    if (
      nextSlide?.classList?.contains("product-media__item") &&
      !nextSlide.classList.contains("scroll-slider__mobile-loop-nav")
    ) {
      currentSlide = nextSlide;
    }

    if (animationFrame !== null) cancelAnimationFrame(animationFrame);

    animationFrame = requestAnimationFrame(() => {
      animationFrame = null;

      if (!mobileQuery.matches) {
        resetDesktopLayout();
        return;
      }

      if (!currentSlide) return;

      // The slider is a flex row containing mixed square and portrait media.
      // Never measure the slide wrapper itself: it can already be inflated by
      // the tallest sibling. Instead derive image height from the image's
      // intrinsic width/height attributes and its actual rendered width.
      slider.style.setProperty("align-items", "flex-start", "important");
      slider.style.setProperty("min-height", "0", "important");

      const targetHeight =
        getImageDrivenHeight(currentSlide) || getFallbackHeight(currentSlide);

      if (targetHeight > 0) {
        slider.style.setProperty("height", `${targetHeight}px`, "important");
      }
    });
  };

  const changedEvent = `scroll-slider-${scrollerId}:slide-changed`;
  const initializedEvent = `scroll-slider-${scrollerId}:initialized`;

  document.addEventListener(changedEvent, (event) => {
    syncHeight(event.detail?.currentElement || null);
  });

  document.addEventListener(initializedEvent, () => syncHeight());

  window.addEventListener("resize", () => syncHeight(), { passive: true });
  window.addEventListener("orientationchange", () => syncHeight(), {
    passive: true,
  });

  mobileQuery.addEventListener?.("change", () => syncHeight());

  productMedia.querySelectorAll("img").forEach((image) => {
    if (image.complete) return;
    image.addEventListener("load", () => syncHeight(), { once: true });
  });

  syncHeight();
  requestAnimationFrame(() => syncHeight());
}

document
  .querySelectorAll("main-product-default product-media[js-product-media]")
  .forEach(initBivTshirtMobileGalleryAutoHeight);
